import './CustomTooltip.css'
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#EB6200',
      color: '#fff',
      fontFamily: 'IBM Plex Sans',
      fontStyle: 'normal',
      fontSize: '10px',
      lineHeight: '12px',
      borderRadius: '2px',
      letterSpacing: '0.32px',
      fontWeight: 600,
      textTransform: 'uppercase'
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#EB6200',
      },
  }));

  export default CustomTooltip